import { render } from "./Query_view.vue?vue&type=template&id=c2a49a5a&scoped=true"
import script from "./Query_view.vue?vue&type=script&lang=js"
export * from "./Query_view.vue?vue&type=script&lang=js"

import "./Query_view.vue?vue&type=style&index=0&id=c2a49a5a&lang=less&scoped=true"

import exportComponent from "D:\\Git仓库\\象新力官网\\html_xxldx_xxlx_xxlg\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2a49a5a"]])

export default __exports__